import React from 'react';
import { Result, Button } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './style.scss';

interface UnauthorizedLocationState {
  missingPermission?: string;
}

interface UnauthorizedProps {
  title?: string;
  subTitle?: string;
  missingPermission?: string;
  showBackButton?: boolean;
  showHomeButton?: boolean;
}

export const Unauthorized: React.FC<UnauthorizedProps> = ({
  title,
  subTitle,
  missingPermission: missingPermissionProp,
  showBackButton = true,
  showHomeButton = true,
}) => {
  const history = useHistory();
  const location = useLocation<UnauthorizedLocationState>();
  const { t } = useTranslation();

  const missingPermission =
    missingPermissionProp || location.state?.missingPermission;

  const defaultTitle = t('unauthorized.title', 'Access Denied');
  const defaultSubTitle = missingPermission
    ? t(
        'unauthorized.subtitleWithPermission',
        'You do not have permission to perform this action (Permission: {{permission}})',
        { permission: missingPermission }
      )
    : t(
        'unauthorized.subtitle',
        'You do not have permission to access this page.'
      );

  const handleGoBack = () => {
    history.goBack();
  };

  const handleGoHome = () => {
    history.push('/');
  };

  return (
    <div className="unauthorized-container">
      <Result
        status="403"
        title={title || defaultTitle}
        subTitle={subTitle || defaultSubTitle}
        extra={
          <div className="unauthorized-actions">
            {showBackButton && (
              <Button type="primary" onClick={handleGoBack}>
                {t('unauthorized.goBack', 'Go Back')}
              </Button>
            )}
            {showHomeButton && (
              <Button onClick={handleGoHome}>
                {t('unauthorized.goHome', 'Go Home')}
              </Button>
            )}
          </div>
        }
      />
    </div>
  );
};

export default Unauthorized;
